import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewCompanyUserWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CompanyUserManagement/NewCompanyUserWrapper").then((module) => ({
    default: module.NewCompanyUserWrapper,
  }))
);

export const newCompanyUserNRO: NavigationRoutingObject = {
  Component: NewCompanyUserWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-company-user-nro-heading", "New Company User"),
  pageNameForTracking: () => "New Company User",
  getDeveloperNavigationAllowed: ({ hasPermissionForAnyScope, isFreeTrial }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component

    if (isFreeTrial) {
      return hasPermissionForAnyScope("viewFreeTrialDevelopers");
    }

    return hasPermissionForAnyScope("editDashboardUsers");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/company_users/:appGroupId",
};
